import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import Modal from 'react-modal';
import _get from 'lodash/get';
import {getLangCode, stringBundle} from '../../stringBundle';
import {accountContactPreferences} from '../../actions/account';
import EditSMSModalForm from './EditSMSModalForm';
import {modalStyles} from '../common/ModalStyles';
import utils from '../../helpers/utils';
import ModalFooter from '../../components/common/ModalFooter';
import CloseIcon from '../../components/common/CloseIcon';

class SMSModal extends Component {

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.localizedStringBundle = stringBundle(getLangCode());
  }

  handleSubmit(values) {
    let accountId = _get(this.props.auth, 'currentLoggedInUser.accountId');
    let updatePrefData = {
      method: 'post',
      body: {
        smsNumber: values.phoneNumber,
        smsOptIn: true
      },
      origin: 'SMS'
    }
    this.props.dispatch(accountContactPreferences(updatePrefData, null, accountId));

    let statusInfo = {
      header: this.localizedStringBundle.MANAGE_MODAL_SMS_HEADER,
      icon: this.localizedStringBundle.MANAGE_MODAL_SMS_ICON,
      message: this.localizedStringBundle.MANAGE_FORM_UPDATE_SUCCESS_MESSAGE,
      origin: 'SMS'
    }
    this.props.dispatch({
      type: 'SHOW_MODAL',
      modalType: 'MA_ALERT_PREF_STATUS_MODAL',
      modalProps: {
        data: statusInfo
      }
    });
    utils.trackEventForManageAccount('Contact_Text', this.localizedStringBundle.MANAGE_ACCOUNT_SAVE, true);
  }

  handleClick() {
    utils.trackEventForManageAccount('Contact_Text', this.localizedStringBundle.MANAGE_ACCOUNT_CLOSE, true);
    this.props.dispatch({type: 'HIDE_MODAL'});
  }

  checkModalState() {
    if (this.props.propModal.modalType !== undefined) {
      return true;
    }
    return false;
  }

  render() {
    return (
      <Modal
        isOpen={this.checkModalState()}
        style={modalStyles}
        contentLabel="Receive Text Message Alerts"
        onRequestClose={this.handleClick}
      >
        <div className="flex flex-wrap">
          <div className="flex w-full h-20 py-6 px-4 lg:px-8 justify-between border-b-1 border-grey-lightest">
            <div className="w-5/6">
              <p className="text-xl md:text-2xl lg:text-3xl font-bold uppercase">{this.localizedStringBundle.MANAGE_MODAL_SMS_HEADER}</p>
            </div>
            <div className="ma-modal-close w-1/6 text-right" onClick={this.handleClick}>
              <CloseIcon/>
            </div>
          </div>
          <div className="flex flex-wrap w-full border-b-1 border-grey-lighter">
            <div className="w-full lg:w-2/3 px-4 lg:px-8 mb-10">
              <EditSMSModalForm onSubmit={this.handleSubmit}/>
            </div>
            <div className="hidden sm:block sm:w-full lg:w-1/3 py-4 bg-grey-superlight px-4">
              <p className="text-lg uppercase"> {this.localizedStringBundle.MANAGE_MODAL_SMS_INFO_TITLE} </p>
              <p className="pt-4 text-base text-grey-light"> {this.localizedStringBundle.MANAGE_MODAL_SMS_INFO_TEXT1} </p>
              <p className="pt-4 text-base text-grey-light"> {this.localizedStringBundle.MANAGE_MODAL_SMS_INFO_TEXT2} </p>
              <p className="pt-4 text-base pb-4 text-grey-light"> {this.localizedStringBundle.MANAGE_MODAL_SMS_INFO_TEXT3} </p>
            </div>
          </div>
          <div className="w-full">
            <ModalFooter/>
          </div>
        </div>
      </Modal>
    );
  }

}

SMSModal.propTypes = {
  auth: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  propModal: PropTypes.object
};

function mapStateToProps(state) {
  const {modal, form} = state;

  if (modal) {
    return {propModal: modal, form: form.editnewsms};
  }
  return {propModal: null};
}

export default connect(mapStateToProps)(SMSModal);



// WEBPACK FOOTER //
// ./src/containers/monitoring/SMSModal.js